module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.3@core-js/library/modules/_a-function.js
// module id = 44
// module chunks = 1